export default "https://cdn-static.gokick.com/assets/3cd141d05df56e6b81a0153ff619f4101846aa93/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";